import React from "react";
import { useNavigate } from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';
import { MenuState, NFMStore, setMenuState } from "../stores/store";
import { useSelector } from "react-redux";
import { ReactComponent as PempemLogo } from "../rsc/logo_pempem.svg";
import { t } from "i18next";
import { colorPrimary } from "../rsc/colors/colors";


export function BurgerMenu() {

    const menuState: MenuState = useSelector((state: any) => state.menu.value)
    const navigate = useNavigate()

    return (
        !menuState.isMobile ?
            <div className="pempem-flex-row-center gap5">
                <PempemLogo fill={"#0097A7"}/>
                <p style={{ fontWeight: "1000", fontSize: "20px" }}>Pempem</p>
                <p style={{ fontWeight: "1000", fontSize: "20px", flexShrink: 0, cursor: "pointer" }} onClick={() => navigate('/')}>{t('pempem_header_title')}</p>
            </div>
            :
            <div onClick={() => NFMStore.dispatch(setMenuState({ isMenuOpen: !menuState.isMenuOpen, isMobile: menuState.isMobile }))}>
                <MenuIcon />
            </div>
    )
}